import script from "./ActivationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationsTable.vue?vue&type=script&setup=true&lang=js"

import "./ActivationsTable.vue?vue&type=style&index=0&id=1e01dcc5&scoped=true&lang=css"
script.__scopeId = "data-v-1e01dcc5"

export default script